import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import SectionWrapper from '../SectionWrapper';
import OrganizationSidebar from '../adminSection/OrganizationSidebar';
import DienstleisterSidebar from '../overviewSection/DienstleisterSidebar';

const SIDEBAR_WIDTHS = {
  compact: 426,
  wide: 800
} as const;

const MainLayout: React.FC = () => {
  const location = useLocation();
  const [isWide, setIsWide] = useState(false);

  const sidebarWidth = isWide ? SIDEBAR_WIDTHS.wide : SIDEBAR_WIDTHS.compact;
  const isAdminSection = location.pathname.startsWith('/admin');
  
  const handleToggleWidth = () => {
    setIsWide(prev => !prev);
  };

  return (
    <SectionWrapper>
      <Box sx={{ 
        display: 'flex', 
        height: 'calc(100vh - 60px)', // Nur Navbar-Abzug
        boxShadow: 'none', 
        paddingX: '1rem'
      }}>
        {isAdminSection 
          ? <OrganizationSidebar isWide={isWide} onToggleWidth={handleToggleWidth} /> 
          : <DienstleisterSidebar isWide={isWide} onToggleWidth={handleToggleWidth} />
        }
        <Box sx={{ 
          marginLeft: `${sidebarWidth + 51}px`,
          flexGrow: 1,
          overflowY: 'auto',
          height: 'calc(100vh - 64px)', // Zurück zur ursprünglichen Höhe
          transition: 'margin-left 0.1s ease-in-out',
          '&::-webkit-scrollbar': {
            width: '0px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: 'transparent',
          },
        }}>
          <Outlet />
        </Box>
      </Box>
    </SectionWrapper>
  );
};

export default MainLayout; 